var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7396 20.7225C15.8859 20.7225 14.7539 16.6893 13.5553 12.4277C12.6897 9.34563 11.6053 5.50259 10.1784 5.50259C6.95366 5.50259 6.84903 12.0947 6.84903 12.1613H4.94653C4.94653 11.8094 5.00361 3.6001 10.1784 3.6001C13.0321 3.6001 14.1831 7.6429 15.3817 11.914C16.1998 14.8248 17.3127 18.82 18.7396 18.82C22.0119 18.82 22.0975 12.2279 22.0975 12.1613H24C24 12.5133 23.9429 20.7225 18.7396 20.7225Z",
    fill: "#4E5968"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.06783 7.54274C9.57287 8.84889 10.0009 10.3665 10.4352 11.914L10.4519 11.9737C11.2684 14.8791 12.3759 18.82 13.7931 18.82C14.0314 18.82 14.2529 18.7851 14.4586 18.7202C14.4587 18.7202 14.4587 18.7203 14.4587 18.7204C14.756 19.3006 15.1095 19.8675 15.5349 20.3592C15.0301 20.5905 14.453 20.7225 13.7931 20.7225C10.9417 20.7225 9.80924 16.696 8.61177 12.4383L8.60878 12.4277C8.46276 11.9078 8.31051 11.3662 8.15145 10.8251C8.21279 10.3134 8.31053 9.708 8.46601 9.10802C8.62396 8.49853 8.82573 7.95882 9.06783 7.54274ZM6.47313 3.89247C6.09787 3.70269 5.68647 3.6001 5.23186 3.6001C0.0570747 3.6001 0 11.8094 0 12.1613H1.90249C1.90249 12.0947 2.00713 5.50259 5.23186 5.50259C5.24572 5.50259 5.25955 5.50295 5.27334 5.50368C5.59346 4.925 5.98807 4.36951 6.47313 3.89247ZM17.066 13.4337C17.3378 14.3438 17.629 15.2386 17.9426 16.0032C18.0658 16.3037 18.1861 16.5678 18.3022 16.7942C19.0382 14.6301 19.0535 12.3435 19.0535 12.1613H17.151C17.151 12.1797 17.1444 12.696 17.066 13.4337Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhases);
export default __webpack_public_path__ + "static/media/Phases.9e594cb81669fbabb51278447d8ebb2a.svg";
export { ForwardRef as ReactComponent };